import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoSparklineMixin from './KendoSparklineMixin'

export default {
    name: 'kendo-sparkline',
    mixins: [ KendoSparklineMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('span', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/index.js